import { Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import type { UserProfile } from "@/types/user-profile";

interface ProfileCardProps {
  profile: UserProfile;
  onViewPermissions: (profile: UserProfile) => void;
}

export function ProfileCard({ profile, onViewPermissions }: ProfileCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <div className="space-y-1">
          <CardTitle className="text-xl font-bold">{profile.name}</CardTitle>
          <Badge variant={profile.is_active ? "default" : "secondary"}>
            {profile.is_active ? "Ativo" : "Inativo"}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {profile.description && (
          <CardDescription>{profile.description}</CardDescription>
        )}
        <div className="text-sm">
          <span className="font-medium">Telas permitidas:</span>{" "}
          {profile.allowed_screens.length}
        </div>
        <div className="flex items-center justify-end gap-2 pt-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onViewPermissions(profile)}
          >
            <Eye className="h-4 w-4 mr-2" />
            Ver Permissões
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

